const SubmissionStatus = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  AWAITING_RETRY_SUBMISSION: 'AWAITING_RETRY_SUBMISSION',
  AWAITING_RETRY_RESUBMISSION: 'AWAITING_RETRY_RESUBMISSION',
  AWAITING_RETRY_SELECT_AND_CONNECT_RESUBMISSION:
    'AWAITING_RETRY_SELECT_AND_CONNECT_RESUBMISSION',
  AWAITING_PARTIAL_SUBMISSION: 'AWAITING_PARTIAL_SUBMISSION',
  AWAITING_RETRY_PARTIAL_SUBMISSION: 'AWAITING_RETRY_PARTIAL_SUBMISSION',
};

export default SubmissionStatus;
